// Taşeron portalı — Belgeler'in "bekleyen onay" şeridi (plan S19-D7, tasarım review §4/§15,
// AC11). `GET .../document-analyses?status=awaiting-review` (§20.3) — `Succeeded`, en az bir
// kalemi `AcceptedDocumentUuid IS NULL` olan analizler. Bu şerit "AI her zaman okur" akışının
// yükleme İLE kabul arasındaki tek görünürlüğüdür: sayfa yenilemesi/sekme kapatma sonrası
// tepsi (`DocumentAnalysisTray`) BELLEK-İÇİ durumunu kaybeder, bu sorgu kaybetmez (§20.3
// TARİHSEL kayıt üzerinden çalışır, `503`/allowlist'e bakmaz).
//
// **Bulgu (owner raporu): tek toplu satır + tek CTA hedefi bozuktu.** Toplam
// `pendingItemCount` TÜM analizler üzerinden toplanıp gösteriliyor, CTA ise yalnız EN
// YENİ analize gidiyordu — 8 diyen bir satırın arkasında 2 belgelik bir analiz açılıyordu ve
// daha eski analizlerin dokümanlarına UI'de HİÇBİR yoldan ulaşılamıyordu (liste ucu var, liste
// SAYFASI yok — `router.tsx`'te yalnız `/document-analysis/:uuid`). Düzeltme: her bekleyen
// analiz KENDİ satırını alır, KENDİ `pendingItemCount`'una ve KENDİ `uuid`'ine bağlanır — bir
// satırdaki sayı o satırın linkinin arkasındaki sayıyla HER ZAMAN eşittir. Liste ZATEN
// `queuedAt` azalan sırada gelir (§20.3) — istemci yeniden SIRALAMAZ. Satırlar `pendingItemCount`
// sıfıra düşmedikçe (kabul sonrası) listeden düşmez, ÇAPRAZLANMAZ/`+N daha` ile GİZLENMEZ — bir
// üst sınır aynı hatayı (erişilemez belge) başka bir eşikte yeniden üretir.
//
// CTA turuncu DEĞİL (`secondary`) — sayfada turuncu yalnız `Belge Yükle`'dir (tasarım §4/AC30).
//
// **`scope` (GL5).** Verilmezse Belgeler'in bugünkü KAPSAMSIZ şeridi (her analiz). Personel
// çekmecesi `{ kind: 'personnel', userUuid }` geçer: yalnız o kişiden başlatılan analizler —
// `StrandedAnalysesStrip`'in AYNI `scopeMatches` kuralı, ayrı bir süzgeç İCAT EDİLMEZ. Önbellek
// girdisi ortaktır (tek istek), süzme istemcidedir.

import { Button, Card, currentCulture } from '@isgportal/shared';
import { Inbox } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { formatDateTime } from '../lib/format';
import { useDocumentAnalysisList } from '../lib/useDocumentAnalysis';
import { scopeMatches } from './StrandedAnalysesStrip';
import type { StrandedTarget } from './StrandedLinkModal';

export function PendingAnalysesStrip({ scope }: { scope?: StrandedTarget }) {
  const { t } = useTranslation();
  const { items, isPending } = useDocumentAnalysisList('awaiting-review');
  const culture = currentCulture();

  if (isPending) {
    return null;
  }

  // Savunmacı süzgeç: uç zaten yalnız `pendingItemCount > 0` analizleri döner (§20.3), ama
  // bu satır o sözleşmeyi istemci tarafında da tekrarlar — sıfır kalemli bir analiz asla bir
  // sayı iddia eden ama arkasında hiçbir şey olmayan satır ÜRETMEZ.
  const rows = items.filter(
    (item) => item.pendingItemCount > 0 && (!scope || scopeMatches(item, scope)),
  );
  if (rows.length === 0) {
    return null;
  }

  return (
    <Card className="border-border-strong">
      <ul className="flex flex-col divide-y divide-border">
        {rows.map((item) => (
          <li key={item.uuid} className="flex flex-wrap items-center justify-between gap-3 p-4">
            <div className="flex items-start gap-3">
              <Inbox className="mt-0.5 h-5 w-5 shrink-0 text-fg" aria-hidden="true" />
              <div>
                <p className="text-sm font-medium text-fg">
                  {t('documents.pending.title', { count: item.pendingItemCount })}
                </p>
                {item.subjectUserUuid !== null ? (
                  <p className="mt-0.5 text-xs text-muted">
                    {t('documents.pending.personnel', { count: item.pendingItemCount })}
                  </p>
                ) : null}
                <p className="mt-0.5 text-xs text-muted">
                  {t('documents.pending.queuedAt', {
                    date: formatDateTime(item.queuedAt, culture),
                  })}
                </p>
              </div>
            </div>
            <Button asChild variant="secondary" size="sm">
              <Link to={`/document-analysis/${item.uuid}`}>{t('documents.pending.cta')}</Link>
            </Button>
          </li>
        ))}
      </ul>
    </Card>
  );
}
